import { render, staticRenderFns } from "./criteria-questions.vue?vue&type=template&id=a562e9fe&scoped=true&"
import script from "./criteria-questions.vue?vue&type=script&lang=ts&"
export * from "./criteria-questions.vue?vue&type=script&lang=ts&"
import style0 from "./criteria-questions.vue?vue&type=style&index=0&id=a562e9fe&lang=scss&scoped=true&"
import style1 from "./criteria-questions.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a562e9fe",
  null
  
)

export default component.exports